import { computed, ref } from "vue";
import { type CategoryId, CategoryId_Schema } from "@/services/collection/categories/categoriesSchema";
import { getCookie, setCookie } from "@/services/cookies";
import { CookieName, CookieRegistry } from "@/services/cookieRegistry";

const { name: cookieName, expirationDays } = CookieRegistry[CookieName.RememberedCategory];

function getCookieExpiration(): string {
  const date = new Date();
  date.setDate(date.getDate() + expirationDays);
  return date.toUTCString();
}

const _categoryId = ref<CategoryId | null>(parseCategoryFromCookie());

function parseCategoryFromCookie(): CategoryId | null {
  const raw = getCookie(cookieName);
  if (!raw) return null;

  const parsed = CategoryId_Schema.safeParse(Number(raw));
  return parsed.success ? parsed.data : null;
}

export function useRememberedCategory() {
  const rememberedCategoryId = computed(() => _categoryId.value);

  function rememberCategoryId(categoryId: CategoryId): void {
    _categoryId.value = categoryId;
    setCookie(cookieName, String(categoryId), { expiration: getCookieExpiration(), path: "/" });
  }

  return {
    rememberedCategoryId,
    rememberCategoryId,
  };
}
